let navigator = null
let dispatcher;

export const naviagetFn = (navigateFn) => {
    navigator = navigateFn;
};
export const navigate = (data, state) => {
    return navigator(data, state);
}

//** D I S P A T C H **/

export const dispatchFn = (dispatch) => {
    dispatcher = dispatch;
  };
  export const dispatch = (data) => {
    return dispatcher(data);
  };
  